module.exports = __webpack_public_path__ + "img/企业logo@2x.2a4f5d3d.png";